import $ from 'jquery';
// import '../../node_modules/core-js/features/object/assign';
// import '../../node_modules/core-js/features/promise';
// import '../../node_modules/core-js/features/array/find';
import tippy from 'tippy.js';

$.addInit(function(context){
	var base = '[rel="tooltip"]';
	$(base, context).each(function(i, el){
		tippy(el, {
			content: function content(reference) {
				return reference.getAttribute('title')
			},
			allowHTML: true,
			theme: 'gray',
			interactive: true,
			appendTo: function appendTo() {
				return document.body;
			},
			maxWidth: 240,
			placement: 'top',
		});
	});
});